import { Box, Button, TextField, Typography } from '@mui/material';
import React, { useState, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { NavLink as RouterLink } from 'react-router-dom';

import { If } from 'app/components/if';
import { GeneralConstants } from 'app/constants/general-constants';
import { useCallbackOnProdSwitch } from 'app/hooks';
import { Category } from 'app/model/cris/category';
import { categoryService } from 'app/services/category.service';
import { CategoryListGrid } from 'features/cris/categories/category-list-grid';

import { selectProdDataStatus } from '../cris.slice';

export const CategorySearch: React.FunctionComponent = () => {
    const [categories, setCategories] = useState<Category[]>([]);
    const showProd = useSelector(selectProdDataStatus);
    const queryRef = useRef<HTMLInputElement>();

    const findCategories = useCallback(() => {
        if (!queryRef.current) {
            return;
        }
        categoryService
            .listAll({
                pageSize: GeneralConstants.PAGE_SIZE_HUGE,
                extraParams: { name: queryRef.current.value },
            })
            .subscribe(setCategories);
    }, []);

    useCallbackOnProdSwitch(findCategories);

    return (
        <>
            <Typography variant='body1' className='mb-1'>
                Search for CRIS Categories within the system.
            </Typography>
            <form
                onSubmit={(evt) => {
                    evt.preventDefault();
                }}
            >
                <Box display='flex' mb={1}>
                    <Box flexGrow={1} mr={1}>
                        <TextField
                            name='term'
                            label='Search Term'
                            variant='outlined'
                            size='small'
                            inputRef={queryRef}
                            fullWidth
                        />
                    </Box>
                    <Button variant='contained' color='primary' type='submit' onClick={findCategories}>
                        Search
                    </Button>
                    <If condition={!showProd}>
                        <Button
                            type='button'
                            variant='outlined'
                            color='warning'
                            className='ml-1'
                            component={RouterLink}
                            to='/cris/categories/new'
                        >
                            Create Category
                        </Button>
                    </If>
                </Box>
            </form>
            <CategoryListGrid
                rows={categories}
                paginationModel={{ pageSize: 50, page: 0 }}
                disableRowSelectionOnClick
                density='compact'
                pagination
            />
        </>
    );
};
